module.exports = __webpack_public_path__ + "img/google-play-badge-sv.f6e7ff40.png";